import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import { date_format, datetime_format } from "../Common/DateFormat";
import DescriptionIcon from "@material-ui/icons/Description";
import { API_URL, BACKEND_URL } from "../constants.js";
import {
  printReportUrl,
  printPatientDetailUrl,
  printNewReportUrl,
  patientEditUrl,
  patientDuplicateUrl,
  getPatientSampleId,
} from "../Common/patientIdentifier";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import EmailIcon from "@material-ui/icons/Email";
import RateReviewIcon from "@material-ui/icons/RateReview";
import SettingsIcon from "@material-ui/icons/Settings";
import ArchiveIcon from "@material-ui/icons/Archive";
import FileCopyIcon from "@material-ui/icons/FileCopy";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import LinkIcon from "@material-ui/icons/Link";
import { submitLabResult, generateReport } from '../services/docusApi';
export function PatientFilter(props) {
  const { t } = useTranslation();
  const sample_id = useRef();
  const test_id = useRef();
  const name = useRef();
  const phone_no = useRef();
  const collection_center_id = useRef();
  const booking = useRef();
  const status = useRef();
  const from_date = useRef();
  const to_date = useRef();
  const changedStatus = useRef();
  const status_created_at = useRef();
  const report_created_datetime = useRef();
  const [reportStatuses, setReportStatuses] = useState([]);
  const notes = useRef();
  const add_notes = useRef();

  const [disabled, setDisabled] = useState(0);
  const [iconDisabled, setIconDisabled] = useState(1);
  const [patients, setPatients] = useState([]);
  const [collectionCenters, setCollectionCenters] = useState([]);
  const [tests, setTests] = useState([]);
  const [patient, setPatient] = useState(null);
  const [show, setShow] = useState(false);
  const [showReportLogModal, setShowReportLogModal] = useState(false);
  const [reportLogParam, setReportLogParam] = useState(false);
  const [statusModalShow, setStatusModalShow] = useState(false);
  const [selectedPatientStatus, setSelectedPatientStatus] = useState("0");
  const [reportCreatedDateTime, setReportCreatedDateTime] = useState(null);
  const [action, setAction] = useState(false);
  const [showDeleteReport, setShowDeleteReport] = useState(false);
  const [addNotesModal, setaddNotesModal] = useState(false);

  const history = useHistory();
  const { authUser } = useSelector(
    ({ auth }) => ({
      authUser: auth.user?.data,
    }),
    shallowEqual
  );

  const setCurrentPatient = (patient_id, action) => {
    setPatient(patient_id);
    if (action == "delete") {
      setShow(true);
    } else if (action == "status") {
      let patient = patients.find((patient) => patient.id == patient_id);
      setSelectedPatientStatus(patient.status);
      setStatusModalShow(true);
    } else if (action == "mail") {
      setDisabled(1);
      axios
        .post(API_URL + "patient/send-mail", { id: patient_id })
        .then((response) => {
          setDisabled(0);
          if (response.data.status) {
            alertify.success(response.data.message);
          } else {
            alertify.error(response.data.message);
            return null;
          }
        });
    } else if (action == "review-mail") {
      setDisabled(1);
      axios
        .post(API_URL + "patient/send-review-email", { id: patient_id })
        .then((response) => {
          setDisabled(0);
          if (response.data.status) {
            alertify.success(response.data.message);
          } else {
            alertify.error(response.data.message);
          }
        })
        .catch(() => {
          setDisabled(0);
          alertify.error("Failed to send feedback email");
        });
    } else if (action == "report") {
      let patient = patients.find((patient) => patient.id == patient_id);
      // console.log(patient.report_created_status_log);
      setReportCreatedDateTime(
        patient.report_created_status_log.created_at_formatted
      );
      setShowReportLogModal(true);
    } else if (action == "delete-report") {
      setShowDeleteReport(true);
    } else if (action == "has_haemolusis") {
      sendQuickAction(patient_id, action);
    } else if (action == "docus_access_link") {
      sendDocusAccessLink(patient_id);
    }
  };

  const sendQuickAction = (patient_id, action) => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-quick-action", {
        id: patient_id,
        action: action,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setPatients((patients) =>
            patients.map((p) =>
              p.id === patient_id ? { ...p, [action]: !p[action] } : p
            )
          );
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const handleClose = () => {
    setStatusModalShow(false);
    setShow(false);
    setShowReportLogModal(false);
    setShowDeleteReport(false);
    setaddNotesModal(false);
  };

  const deletePatient = (e) => {
    e.preventDefault();
    axios
      .post(API_URL + "patient/" + patient + "/delete", { id: patient })
      .then((response) => {
        if (response.data.status) {
          history.go(0);
          setShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const deletePatientReport = () => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/delete-report", {
        id: patient,
        action: action,
      })
      .then((response) => {
        if (response.data.status) {
          history.go(0);
          setShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const patientFilterHandler = (e) => {
    e.preventDefault();
    setDisabled(1);
    setIconDisabled(0);
    axios
      .post(API_URL + "patient/filter", {
        sample_id: sample_id.current.value,
        test_id: test_id.current.value,
        name: name.current.value,
        phone_no: phone_no.current.value,
        from_date: from_date.current.value,
        to_date: to_date.current.value,
        collection_center_id: collection_center_id.current.value,
        booking: booking.current.value,
        report_status_id: status.current.value,
      })
      .then((response) => {
        setDisabled(0);
        setIconDisabled(1);
        console.log(response.data.data.patients);
        if (response.data.status) {
          setPatients(response.data.data.patients);
        } else {
          return null;
        }
      });
  };

  const changeStatusHandler = (e) => {
    e.preventDefault();
    setDisabled(1);
    setIconDisabled(0);
    axios
      .post(API_URL + "patient/change-status", {
        id: patient,
        report_status_id: changedStatus.current.value,
        status_created_at: status_created_at.current.value,
        notes: notes.current.value,
      })
      .then((response) => {
        setDisabled(0);
        setIconDisabled(1);
        if (response.data.status) {
          history.go(0);
          setShow(false);
          setStatusModalShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const changeReportLogHandler = (e) => {
    e.preventDefault();
    setDisabled(1);
    setIconDisabled(0);
    axios
      .post(API_URL + "patient/change-report-created-status-log", {
        patient_id: patient,
        report_created_datetime: report_created_datetime.current.value,
      })
      .then((response) => {
        setDisabled(0);
        setIconDisabled(1);
        if (response.data.status) {
          setShowReportLogModal(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }

        history.go(0);
      });
  };

  const selectedPatientStatusHandler = (e) => {
    setSelectedPatientStatus(e.target.value);
  };

  useEffect(() => {
    axios
      .get(API_URL + "patient")
      .then((response) => {
        if (response.data.status) {
          setPatients(response.data.data.patients);
          setCollectionCenters(response.data.data.collectioncenters);
          setTests(response.data.data.tests);
          // $("#patient_table").DataTable();
        } else {
          alertify.error(response.data.message);
          return null;
        }
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          //props.logout();
        }
      });

    const params = new URLSearchParams(window.location.search);
    if (params.get("report")) setReportLogParam(params.get("report"));
  }, []);

  useEffect(() => {
    axios.get(API_URL + "report-status").then((response) => {
      if (response.data.status) {
        setReportStatuses(response.data.data);
      }
    });
  }, []);

  const archivePatient = (id) => {
    console.log("id", id);
    setDisabled(1);
    axios.post(API_URL + `patient/${id}/archive`).then((response) => {
      setDisabled(0);
      console.log("response", response);
      if (response.data.status == true) {
        setPatients(
          patients.filter((val) => {
            return val.id != id;
          })
        );
        alertify.success(response.data.message);
      } else {
        alertify.error(response.data.message);
        return null;
      }
    });
  };
  const handleSendToDocus = async (patientId) => {
    try {
        const submitRes = await submitLabResult(patientId);
        if (!submitRes.success) {
            alert('Error: ' + JSON.stringify(submitRes.error));
            return;
        }
        const genRes = await generateReport(patientId);
        if (genRes.success) {
            alert("✅ Documents report has been sent successfully!");
        } else {
            alert('Error: ' + JSON.stringify(genRes.error));
        }
    } catch (err) {
        alert('Network error: ' + err.message);
    }
};

  const handleDocusSubmit = async (patient) => {
    setDisabled(1);
    try {
      const res = await submitLabResult(patient.sample_id);
      if (res.success) {
        alertify.success("Lab results submitted to Docus successfully");
        setPatients((patients) =>
          patients.map((p) =>
            p.id === patient.id
              ? { ...p, has_docus_result_submitted: true }
              : p
          )
        );
      } else {
        alertify.error("Error: " + JSON.stringify(res.error));
      }
    } catch (err) {
      alertify.error("Network error: " + err.message);
    } finally {
      setDisabled(0);
    }
  };

  const handleDocusDownload = (patient) => {
    if (!patient.docus_received_at || !patient.docus_patient_access_url) return;
    window.open(patient.docus_patient_access_url, "_blank");
  };

  const sendDocusAccessLink = (patient_id) => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-docus-access-link", { id: patient_id })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          alertify.success(
            response.data.message ||
              "Docus access link email sent successfully."
          );
        } else {
          alertify.error(
            response.data.message ||
              "Failed to send Docus access link email."
          );
          return null;
        }
      })
      .catch((error) => {
        setDisabled(0);
        alertify.error(
          error.response?.data?.message ||
            error.message ||
            "Failed to send Docus access link"
        );
      });
  };
  const addNotes = (e) => {
    e.preventDefault();
    // setDisabled(1);
    // axios.post(
    //     API_URL + 'patient/add-additional-remarks',
    //     {
    //         id: patient,
    //         additional_remarks: additional_remarks.current.value
    //     }
    // ).then((response) => {
    //     setDisabled(0);
    //     if (response.data.status) {
    //         setAdditionalRemarksModal(false);
    //         setPatients(patients =>
    //             patients.map(p =>
    //                 p.id === patient
    //                     ? { ...p, additional_remarks: additional_remarks.current.value }
    //                     : p
    //             )
    //         );
    //         alertify.success(response.data.message);
    //     } else {
    //         alertify.error(response.data.message);
    //         return null;
    //     }
    // })
  };

  return (
    <>
      <style>{`.patient-actions .btn:hover svg { color: currentColor !important; }`}</style>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title="Patients List">
              <CardHeaderToolbar>
                <Link
                  to="/patient/create"
                  className="btn btn-primary btn-sm mx-3"
                >
                  Create Patient
                </Link>
              </CardHeaderToolbar>
            </CardHeader>
            <div className={"mt-5"}>
              <Form onSubmit={patientFilterHandler}>
                <Row className={"ml-5  mr-5 mb-10 "}>
                  <Col xs={12} md={4}>
                    <Form.Label>Collection Center</Form.Label>
                    <Form.Control as="select" ref={collection_center_id}>
                      <option value="0" key={"collection_center_0"}>
                        Choose...
                      </option>

                      {collectionCenters.map((collection_center, index) => (
                        <option
                          key={`collection_center_` + index}
                          value={collection_center.id}
                        >
                          {collection_center.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Test Type</Form.Label>
                    <Form.Control as="select" ref={test_id}>
                      <option value="0" key={"test_0"}>
                        Choose...
                      </option>

                      {tests.map((test, index) => (
                        <option key={"test_" + index} value={test.id}>
                          {test.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control ref={name} placeholder="Search by Name" />
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Phone No</Form.Label>
                    <Form.Control
                      ref={phone_no}
                      placeholder="Search by Phone"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Booking</Form.Label>
                    <Form.Control as="select" ref={booking}>
                      <option value="0" key={"booking"}>
                        Choose...
                      </option>
                      <option value="inlab" key={"inlab"}>
                        Inlab
                      </option>
                      <option value="online" key={"online"}>
                        Online
                      </option>
                    </Form.Control>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Status</Form.Label>
                    <Form.Control as="select" ref={status}>
                      <option value="0" key={"status_0"}>
                        Choose...
                      </option>
                      {reportStatuses.map((status) => (
                        <option value={status.id} key={"status_" + status.id}>
                          {status.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>From Date</Form.Label>
                    <Form.Control
                      type={"date"}
                      ref={from_date}
                      placeholder="Search by From Date"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>To Date</Form.Label>
                    <Form.Control
                      type={"date"}
                      ref={to_date}
                      placeholder="Search by To Date"
                    />
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Label>Sample ID</Form.Label>
                    <Form.Control
                      ref={sample_id}
                      placeholder="Search By Sample ID"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={3}></Col>
                  <Col xs={6}>
                    <Button
                      variant="primary"
                      size="lg"
                      className="float-right btn-block"
                      type="submit"
                      disabled={disabled}
                    >
                      Filter
                      <span
                        dangerouslySetInnerHTML={{
                          __html: disabled
                            ? `<i class='fas fa-spinner fa-spin'></i>`
                            : ``,
                        }}
                      />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
            <CardBody style={{ overflow: "auto" }}>
              <table
                id="patient_table"
                className="stratprop_datatable patient_datatable table table-striped table-bordered"
              >
                <thead>
                  <tr>
                    <th style={{ width: "40px" }}>SN.</th>
                    <th style={{ width: "150px" }}>Actions</th>
                    <th style={{ width: "200px" }}>Status</th>
                    <th style={{ width: "240px" }}>Patient</th>
                    <th style={{ width: "200px" }}>Test Type</th>
                    <th style={{ width: "150px" }}>DOB / Gender</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length > 0 ? (
                    patients.map((patient, index) => (
                      <tr key={`patient_${index + 1}`} className={patient.sent_activation_msg == 1 ? 'sent-activation-msg' : ''}>
                        <td>{index + 1}</td>
                        <td>
                          {authUser?.role_id == 4 ? (
                            <div className="d-flex flex-wrap patient-actions" style={{ width: "100px" }}>
                              <Link to={`/patient/edit/${patient.id}`} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Edit Patient">
                                <EditIcon color="inherit" />
                              </Link>
                              <a href={printPatientDetailUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="View Patient Detail">
                                <BeachAccessIcon color="inherit" />
                              </a>
                              <a
                                onClick={() => {
                                  if (!patient.has_docus_result_submitted)
                                    handleDocusSubmit(patient);
                                }}
                                className={`btn btn-outline-info m-1 ${patient.has_docus_result_submitted ? "disabled" : ""}`}
                                style={{ width: "42px", pointerEvents: patient.has_docus_result_submitted ? "none" : "auto" }}
                                aria-disabled={patient.has_docus_result_submitted ? "true" : "false"}
                                title={patient.has_docus_result_submitted ? "Docus: Lab Results Already Submitted" : "Docus: Submit Lab Results"}
                              >
                                <CloudUploadIcon color="inherit" />
                              </a>
                              <a
                                onClick={() => handleDocusDownload(patient)}
                                className={`btn btn-outline-success m-1 ${patient.docus_received_at ? "" : "disabled"}`}
                                style={{ width: "42px", pointerEvents: patient.docus_received_at ? "auto" : "none" }}
                                aria-disabled={patient.docus_received_at ? "false" : "true"}
                                title={patient.docus_received_at ? "Docus: Download Report" : "Docus: Report not received yet"}
                              >
                                <CloudDownloadIcon color="inherit" />
                              </a>
                              <a
                                disabled={disabled}
                                title={"Send Docus Link"}
                                onClick={() =>
                                  setCurrentPatient(patient.id, "docus_access_link")
                                }
                                className="btn btn-outline-info m-1"
                                style={{ width: "42px" }}
                              >
                                <LinkIcon color="inherit"></LinkIcon>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: disabled
                                      ? `<i class='fas fa-spinner fa-spin'></i>`
                                      : ``,
                                  }}
                                />
                              </a>
                            </div>
                          ) : (
                            <div className="d-flex flex-wrap patient-actions" style={{ width: "100px" }}>
                              <Link to={`/patient/edit/${patient.id}`} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Edit Patient">
                                <EditIcon color="inherit" />
                              </Link>
                              <a href={printPatientDetailUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="View Patient Detail">
                                <BeachAccessIcon color="inherit" />
                              </a>
                              <a href={printReportUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Print Report">
                                <DescriptionIcon color="inherit" />
                              </a>
                              <a onClick={() => setCurrentPatient(patient.id, "status")} className="btn btn-outline-secondary m-1" style={{ width: "42px" }} title="Change Status">
                                <AutorenewIcon color="inherit" />
                              </a>
                              <a onClick={() => setCurrentPatient(patient.id, "delete")} className="btn btn-outline-danger m-1" style={{ width: "42px" }} title="Delete Patient">
                                <DeleteForeverIcon color="inherit" />
                              </a>
                              <a disabled={disabled} onClick={() => setCurrentPatient(patient.id, "mail")} className="btn btn-outline-secondary m-1" style={{ width: "42px" }} title="Send Email">
                                <EmailIcon color="inherit" />
                              </a>
                              {patient.report_created_status_log ? (
                                <a disabled={disabled} onClick={() => setCurrentPatient(patient.id, "review-mail")} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Send feedback email">
                                  <RateReviewIcon color="inherit" />
                                </a>
                              ) : null}
                              <a href={printNewReportUrl(patient.sample_id)} target="_blank" className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Print Report New">
                                <DescriptionIcon color="inherit" />
                              </a>
                              <a disabled={disabled} onClick={() => archivePatient(patient.id)} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Archive patient">
                                <ArchiveIcon color="inherit" />
                              </a>
                              <Link to={`/patient/duplicate/${patient.id}`} className="btn btn-outline-primary m-1" style={{ width: "42px" }} title="Duplicate Patient">
                                <FileCopyIcon color="inherit" />
                              </Link>
                              {reportLogParam ? (
                                <a disabled={disabled} onClick={() => setCurrentPatient(patient.id, "report")} className="btn btn-outline-secondary m-1" style={{ width: "42px" }} title="Report Log">
                                  <SettingsIcon color="inherit" />
                                </a>
                              ) : null}
                              <a disabled={disabled} onClick={() => setCurrentPatient(patient.id, "has_haemolusis")} className={`btn m-1 ${patient.has_haemolusis ? "btn-warning" : "btn-outline-warning"}`} style={{ width: "42px" }} title="Haemolusis">
                                <InsertCommentIcon color="inherit" />
                              </a>
                              <a onClick={() => setCurrentPatient(patient.id, "delete-report")} className="btn btn-outline-danger m-1" style={{ width: "42px" }} title="Delete Patient Report">
                                <HighlightOffIcon color="inherit" />
                              </a>
                              <a
                                onClick={() => {
                                  if (!patient.has_docus_result_submitted)
                                    handleDocusSubmit(patient);
                                }}
                                className={`btn btn-outline-info m-1 ${patient.has_docus_result_submitted ? "disabled" : ""}`}
                                style={{ width: "42px", pointerEvents: patient.has_docus_result_submitted ? "none" : "auto" }}
                                aria-disabled={patient.has_docus_result_submitted ? "true" : "false"}
                                title={patient.has_docus_result_submitted ? "Docus: Lab Results Already Submitted" : "Docus: Submit Lab Results"}
                              >
                                <CloudUploadIcon color="inherit" />
                              </a>
                              <a
                                onClick={() => handleDocusDownload(patient)}
                                className={`btn btn-outline-success m-1 ${patient.docus_received_at ? "" : "disabled"}`}
                                style={{ width: "42px", pointerEvents: patient.docus_received_at ? "auto" : "none" }}
                                aria-disabled={patient.docus_received_at ? "false" : "true"}
                                title={patient.docus_received_at ? "Docus: Download Report" : "Docus: Report not received yet"}
                              >
                                <CloudDownloadIcon color="inherit" />
                              </a>
                              <a
                                disabled={disabled}
                                title={"Send Docus Link"}
                                onClick={() =>
                                  setCurrentPatient(patient.id, "docus_access_link")
                                }
                                className="btn btn-outline-info m-1"
                                style={{ width: "42px" }}
                              >
                                <LinkIcon color="inherit"></LinkIcon>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: disabled
                                      ? `<i class='fas fa-spinner fa-spin'></i>`
                                      : ``,
                                  }}
                                />
                              </a>
                            </div>
                          )}
                        </td>
                        {/*<td>{patient.mr}</td>*/}
                        <td>
                          {patient.registered_at ? (
                            <>
                              <span className="badge badge-warning patient-badge text-white patient-badge">
                                Registered @{" "}
                                {patient.registered_at
                                  ? datetime_format(patient.registered_at)
                                  : ""}
                              </span>

                              <br />
                            </>
                          ) : (
                            <></>
                          )}

                          {patient.sample_received_at ? (
                            <>
                              <span className="badge badge-info patient-badge text-white">
                                Received @{" "}
                                {patient.sample_received_at
                                  ? datetime_format(patient.sample_received_at)
                                  : ""}
                              </span>
                              <br />
                            </>
                          ) : (
                            <></>
                          )}

                          {patient.report_status_log
                            .filter(
                              (status_log) => status_log.report_status_id == 5
                            )
                            .reverse()
                            .slice(0, 1) // This ensures only the first match is returned
                            .map((status_log) => (
                              <span
                                className="badge badge-reported patient-badge text-white"
                                key={`report_status_log` + status_log.id}
                              >
                                Reported @{" "}
                                {status_log.created_at_formatted
                                  ? datetime_format(
                                      status_log.created_at_formatted
                                    )
                                  : ""}
                              </span>
                            ))}

                          {patient.royal_mail_tracking_no ? (
                            <p className={`badge badge-light patient-badge`}>
                              Tracking# {patient.royal_mail_tracking_no}
                            </p>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td>
                          <span className={`badge badge-light patient-badge`}>
                            {patient.patient_master?.unique_patient_no}
                          </span>
                          <br />
                          <span className={`badge badge-dark patient-badge`}>
                            {patient.sample_id}
                          </span>
                          <br />
                          <span className={"font-bold"}>
                            {" "}
                            {patient.first_name}
                          </span>
                          <br />
                          <span>{patient.last_name}</span>
                          <br />
                          <a
                            className={`font-bold`}
                            href={`mailto:${patient.email}`}
                          >
                            {patient.email}
                          </a>
                          <br />
                          <a
                            className={`font-bold text-dark`}
                            href={`tel:${patient.phone_no}`}
                          >
                            {patient.phone_no}
                          </a>
                        </td>
                        <td>
                          <ul>
                            {patient.patient_tests.length > 0
                              ? patient.patient_tests.map(
                                  (patient_test, index) => (
                                    <li>{patient_test.test?.name}</li>
                                  )
                                )
                              : ""}
                          </ul>
                        </td>
                        <td>
                          {patient.age_in_years < 18 ? (
                            <>
                              <span className={"badge badge-danger"}>
                                Under 18
                              </span>
                              <br />
                            </>
                          ) : (
                            ""
                          )}
                          <span className={`font-bold`}>{patient.gender}</span>
                          <br />
                          <span>{date_format(patient.dob)}</span>
                          {patient.menstrual_cycle_relation ? (
                            <>
                              <br />
                              <span
                                className="font-bold"
                                style={{
                                  display: "inline-block",
                                  marginTop: "4px",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  backgroundColor: "#f3a6ad",
                                  color: "#721c24",
                                }}
                              >
                                {patient.menstrual_cycle_relation ===
                                  "days_since_last_period" &&
                                patient.menstrual_cycle_day !== null &&
                                patient.menstrual_cycle_day !== undefined &&
                                patient.menstrual_cycle_day !== ""
                                  ? `${patient.menstrual_cycle_day} `
                                  : ""}
                                {patient.menstrual_cycle_relation
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (letter) =>
                                    letter.toUpperCase()
                                  )}
                              </span>
                            </>
                          ) : null}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={13}>No Patient</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> Delete Patient</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Delete?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={deletePatient}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={statusModalShow} onHide={handleClose}>
        <Form onSubmit={changeStatusHandler}>
          <Modal.Header closeButton>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Col xs={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    ref={changedStatus}
                    value={selectedPatientStatus}
                    onChange={selectedPatientStatusHandler}
                  >
                    <option value="0" key={"0"}>
                      Choose...
                    </option>
                    {reportStatuses.map((status) => (
                      <option value={status.id} key={"status_" + status.id}>
                        {status.name}
                      </option>
                    ))}
                  </Form.Control>

                  <Form.Label>{t("Action Performed At")}</Form.Label>
                  <Form.Control
                    type={"datetime-local"}
                    ref={status_created_at}
                    placeholder={t("Action Performed At")}
                  />
                </Col>
                <Col xs={12}>
                  <Form.Label>Notes</Form.Label>
                  <Form.Control as="textarea" ref={notes}></Form.Control>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Change Status
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showReportLogModal} onHide={handleClose}>
        <Form onSubmit={changeReportLogHandler}>
          <Modal.Header closeButton>
            <Modal.Title>Change Report Date Time</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Reported Date")}</Form.Label>
                  <Form.Control
                    type={"datetime-local"}
                    ref={report_created_datetime}
                    placeholder={t("Reported Date")}
                    defaultValue={reportCreatedDateTime}
                  />
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Change
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showDeleteReport} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Delete Patient / Report")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("Are you sure you want to Delete?")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close")}
          </Button>
          <Button
            variant="primary"
            disabled={disabled}
            onClick={deletePatientReport}
          >
            {t("Confirm")}
            <span
              dangerouslySetInnerHTML={{
                __html: disabled
                  ? `<i class='fas fa-spinner fa-spin'></i>`
                  : ``,
              }}
            />
          </Button>
        </Modal.Footer>
      </Modal>
      {/* set notes model */}
      <Modal show={addNotesModal} onHide={handleClose}>
        <Form onSubmit={addNotes}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Add Notes")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Enter Notes")}</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    // defaultValue={singlePatient?.additional_remarks || ""}
                    ref={add_notes}
                    placeholder={t("Notes")}
                  />
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Close")}
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Save
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled ? (
                    <i class="fas fa-spinner fa-spin"></i>
                  ) : (
                    ``
                  ),
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
